import { createSelector } from 'reselect'

import { selectLandingState } from './selectLandingState'

export const selectSearchValue = createSelector(
  [selectLandingState],
  ({ searchValue }) => searchValue
)
